import modalTypes from 'constants/AppModalTypes';
import { openModalDialog } from '@nextiva/crm-modals';

export const openChangeScaleItemCount = (
  questionId,
  isIncrement = true,
  index,
) =>
  openModalDialog({
    type: modalTypes.scaleChangeItemCount,
    questionId,
    isIncrement,
    index,
  });

export const openChangeScaleStartFromZero = (questionId, startFromZero) =>
  openModalDialog({
    type: modalTypes.scaleChangeStartFromZero,
    questionId,
    startFromZero,
  });

export const openRemoveBlockWithLogicModal = (
  questionId,
  isInsideOtherLogicQuestion,
) =>
  openModalDialog({
    type: modalTypes.removeBlockWithLogic,
    questionId,
    isInsideOtherLogicQuestion,
  });

export const openDeleteOptionWithLogicModal = (questionId, index) =>
  openModalDialog({
    type: modalTypes.deleteOptionWithLogic,
    questionId,
    index,
  });
